import { useEffect, useState } from "react";
import { brandMeta, navLinks } from "@/mocks/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("intro");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const ids = navLinks.map((l) => l.id);
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 30);
      setShowTop(y > 600);
      let current = "intro";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) {
          current = id;
        }
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#fff8f0]/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav
        aria-label="主导航"
        className="mx-auto flex max-w-6xl items-center justify-between px-4 md:px-6 h-16 md:h-[72px]"
      >
        <a
          href="#top"
          className="flex items-center gap-2 whitespace-nowrap"
          onClick={() => setOpen(false)}
        >
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-rose-500 to-orange-400 text-white text-lg">
            <i className="ri-chat-smile-3-line" aria-hidden="true" />
          </span>
          <span className="font-heading text-xl md:text-2xl text-stone-800">
            {brandMeta.name}
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <li key={l.id}>
              <a
                href={`#${l.id}`}
                className={`block whitespace-nowrap rounded-full px-3.5 py-2 text-sm transition-colors ${
                  active === l.id
                    ? "bg-rose-500 text-white"
                    : "text-stone-600 hover:bg-white hover:text-rose-600"
                }`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          aria-label="打开菜单"
          className="grid h-10 w-10 place-items-center rounded-lg bg-white/70 text-xl text-stone-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-stone-200/70 bg-[#fff8f0]/98 backdrop-blur-md px-4 py-3">
          <ul className="grid grid-cols-2 gap-1">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  onClick={() => setOpen(false)}
                  className={`block whitespace-nowrap rounded-full px-4 py-2.5 text-sm ${
                    active === l.id
                      ? "bg-rose-500 text-white"
                      : "text-stone-700 hover:bg-orange-100"
                  }`}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {showTop && (
        <button
          type="button"
          aria-label="回到顶部"
          onClick={goTop}
          className="fixed bottom-6 right-6 z-50 grid h-11 w-11 place-items-center rounded-full bg-rose-500 text-white text-xl shadow-soft transition-transform hover:-translate-y-1 hover:bg-rose-600"
        >
          <i className="ri-arrow-up-line" aria-hidden="true" />
        </button>
      )}
    </header>
  );
}